import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { REGULATIONS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/regulations/new")({
  component: () => <DeptContentForm cfg={REGULATIONS} />,
});
